import React from 'react';
import { Tooltip } from '@mui/material';
import { ImagePlus, Info, Megaphone, Trash2 } from 'lucide-react';
import { Toggle } from './LinksConfigUi';

export default function LinksConfigPromotionPanel({
  promotion,
  setRestaurant,
  uploadError,
  uploadingImage,
  isUploadingImage,
  onSelectImage,
  onRemoveImage,
}) {
  const hasImage = Boolean(promotion?.image);
  const enabled = Boolean(promotion?.enabled && hasImage);

  const togglePromotion = () => {
    if (!hasImage) return;
    setRestaurant((current) => ({
      ...current,
      promotion: {
        ...(current.promotion || {}),
        enabled: !current.promotion?.enabled,
      },
    }));
  };

  return (
    <section className="fsl-card">
      <div className="fsl-card-head">
        <h2 className="fsl-card-title">
          Banner promocional
          <Tooltip
            title="Exibe a promoção ao abrir a página, com X no topo para fechar. Aceita imagens horizontais e verticais, sem esticar, com tamanho máximo próximo à tela do celular. Arraste, amplie ou reduza o zoom; reduzir pode criar margens transparentes. No envio, reduzimos imagens grandes para até 1200 × 1600 px e comprimimos o arquivo para carregar mais rápido. Isso pode suavizar detalhes finos e textos pequenos: confira a prévia."
            arrow
            enterTouchDelay={0}
          >
            <button type="button" className="fsl-infotip" aria-label="Sobre o banner promocional">
              <Info size={14} strokeWidth={2.4} />
            </button>
          </Tooltip>
        </h2>
        <Toggle
          checked={enabled}
          onChange={togglePromotion}
          label="Exibir banner promocional"
          disabled={!hasImage}
        />
      </div>

      {hasImage ? (
        <div className="fsl-promotion-editor">
          <img src={promotion.image} alt="Prévia do banner promocional" />
          <div className="fsl-promotion-editor-actions">
            <label className={`fsl-media-btn ${uploadingImage === 'promotion' ? 'is-loading' : ''} ${isUploadingImage ? 'is-disabled' : ''}`}>
              <ImagePlus size={15} strokeWidth={2.3} />
              {uploadingImage === 'promotion' ? 'Enviando...' : 'Trocar imagem'}
              <input
                type="file"
                accept="image/jpeg,image/png,image/webp"
                disabled={isUploadingImage}
                onChange={(event) => {
                  const file = event.target.files?.[0];
                  event.target.value = '';
                  onSelectImage(file);
                }}
              />
            </label>
            <button
              type="button"
              className="fsl-media-btn fsl-media-btn--ghost"
              onClick={onRemoveImage}
              disabled={isUploadingImage}
            >
              <Trash2 size={15} strokeWidth={2.3} />
              Remover
            </button>
          </div>
        </div>
      ) : (
        <label className={`fsl-promotion-empty ${isUploadingImage ? 'is-disabled' : ''}`}>
          <Megaphone size={24} strokeWidth={2} />
          <strong>Adicionar banner promocional</strong>
          <span>JPG, PNG ou WebP · otimização automática no envio</span>
          <input
            type="file"
            accept="image/jpeg,image/png,image/webp"
            disabled={isUploadingImage}
            onChange={(event) => {
              const file = event.target.files?.[0];
              event.target.value = '';
              onSelectImage(file);
            }}
          />
        </label>
      )}

      {uploadError && <p className="fsl-upload-error">{uploadError}</p>}
    </section>
  );
}
